import React, {useState} from 'react';
import {Button} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import LoadingCircle from "../../../../util/common/LoadingCircle";
import {cancelImportFromSource, startImportFromSource} from "../../../../../state/actions/getDataActions";
import {connect} from "react-redux";
import Alert from "@material-ui/lab/Alert";
import {formatDate, formatStyles} from "../../../../../helpers/FormatUtils";

const useStyles = makeStyles({
  ...formatStyles,
  root:{
  },
  container:{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontSize: "0.7225rem",
    fontWeight: "500",
    textTransform: "uppercase",
    textAlign: "center"
  },
  processing:{
    alignSelf: "center",
    width: "48px",
    height: "48px",
    position: "relative",
    "& > svg:first-child":{
      fontSize: "48px",
      color: "#fff",
    }
  },
  loader:{
    fontSize: "48px !important",
    position: "absolute",
    top: "0px",
    left: "0px"
  },
  label:{
    fontSize: "0.85rem",
    fontWeight: 600,
    // lineHeight: "2.5",
  },
  count:{
    fontSize: "0.95em",
    fontWeight: 500,
    lineHeight: "1.5",
    whiteSpace: "nowrap"
  },
  date:{
    fontSize: "0.95em",
    fontWeight: 400,
    lineHeight: "1.5",
    height: "1.5em",
  },
  action:{
    textDecoration: "underline",
    fontSize: "0.85rem",
    fontWeight: 500,
    textAlign: "center",
    minWidth: "75px",
    lineHeight: "2.5",
  }
});


function ImportButton(props) {
  const {
    source, label, icon, handleConnect, importFormData, mindfile,
    importSource:{item_count=null, status="inactive", end_at=null}={item_count:null, status:"inactive", end_at:null},
    cancelImportFromSource, startImportFromSource
  } = props;
  const classes = useStyles();

  const [connectionMessage, setConnectionMessage] = useState(null);
  const [running, setRunning] = useState(false);

  const connected = !!importFormData;
  const isActive = running || status === "active";
  const actionLabel = isActive ? 'Cancel' : connected ? 'Import' : 'Connect'
  const color = isActive ? 'secondary' : connected ? 'primary' : 'default'

  const connectToSocial = () => {
    clearConnectionMessage();
    handleConnect();
  }

  const downloadFromSocial = () => {
    if (!!importFormData) {
      setRunning(true)
      clearConnectionMessage();
      startImportFromSource(mindfile.id, source, importFormData, () => setRunning(false));
    }
  }

  const cancelDownload = () => {
    cancelImportFromSource(mindfile.id, source, () => setRunning(false))
  }

  const clearConnectionMessage = () => {
    setConnectionMessage(null);
  }

  const onClick = isActive ? cancelDownload : connected ? downloadFromSocial : connectToSocial

  return (
    <>
      {!connectionMessage ? null : <Alert severity={connectionMessage.severity}>{connectionMessage.message}</Alert>}
      <Button
        id={`import${label}`}
        className={classes.root}
        variant="contained"
        color={color}
        onClick={onClick}
      >
        <div className={classes.container}>
          <div className={classes.processing}>
            {icon}
            {isActive ? <LoadingCircle color="primary" size="font" className={classes.loader} /> : null}
          </div>
          <div className={classes.label}>
            {label}
          </div>
          <div className={classes.count}>
            Items: <span id="importCount">{item_count || "--"}</span>
            <div className={classes.date}>
              {!end_at ? " " : <>( {formatDate("importEnd", end_at, classes, "span")} )</>}
            </div>
          </div>
          <div className={classes.action}>
            {actionLabel}
          </div>
        </div>
      </Button>
    </>
  );
}

const mapStateToProps = state => ({
    mindfile: state.mindfile,
});

const mapDispatchToProps = {
  startImportFromSource,
  cancelImportFromSource
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportButton);
